import { useQuery } from '@tanstack/react-query'
import { AccountControllerFindOne } from '@/apis/v1/accounts'
import { PlanControllerGetPlanBundles } from '@/apis/v1/plans'

export const queryKeys = {
  useAccountQuery: ['useAccountQuery'],
  useBillingPriceQuery: ['useBillingPriceQuery'],
  useBillingPlansOptionsQuery: ['useBillingPlansOptionsQuery'],
  usePlansBundlesQuery: ['useBillingPlansBundlesQuery'],
}

export const useAccountQuery = () => {
  return useQuery({
    queryKey: queryKeys.useAccountQuery,
    queryFn: async () => {
      return AccountControllerFindOne({})
    },
  })
}

export const usePlansBundlesQuery = () => {
  return useQuery({
    queryKey: queryKeys.usePlansBundlesQuery,
    queryFn: async () => {
      return PlanControllerGetPlanBundles({})
    },
  })
}
